import Store from 'store/store'
import 'controllers/hotkeys'

import { render } from 'utils/jsx'
import App from 'components/dom/App'

import preload from 'controllers/preload'
import showError from 'controllers/error'

import Landscape from 'controllers/landscape/register'
import APIServer from 'controllers/api-server'
import Browser from 'controllers/browser'

;(async () => {
  // Fail on mobile
  if (window.ENV.production && Browser.isMobile) {
    render((<div class='mobile-warning'>Navigateur mobile non supporté.</div>), document.body)
    document.body.classList.remove('is-loading')
    return
  }

  // Load app
  try {
    Landscape.register()
    APIServer.polling.start()

    APIServer.log('enter', {
      url: window.location.href,
      features: window.ENV.features
    })

    await preload.fonts()
    render(<App />, document.body)

    document.body.classList.remove('is-loading')
  } catch (error) {
    showError(error)
  }
})()

// Log every steps
Store.steps.index.subscribe(index => {
  APIServer.log('step', { step: index })
})

window.onbeforeunload = function () {
  if (window.ENV.production && Store.app.isModified.get()) {
    return 'Vous avez des modifications non-enregistrées, êtes-vous sûr de vouloir quitter ?'
  }
}



// WEBPACK FOOTER //
// ./src/index.js